module.exports = __webpack_public_path__ + "static/media/JPN.85f34b21.svg";